import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Clock } from 'lucide-react';

const IdleWarningModal = ({ 
  isOpen, 
  countdown, 
  onConfirm
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div 
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px',
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            backdropFilter: 'blur(8px)',
          }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 10 }}
            className="glass-card"
            style={{
              width: '100%',
              maxWidth: '400px',
              padding: '32px',
              position: 'relative',
              overflow: 'hidden',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255,255,255,0.1)',
              textAlign: 'center'
            }}
          >
            <div style={{
              width: '64px',
              height: '64px',
              borderRadius: '50%',
              backgroundColor: 'rgba(234, 179, 8, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px auto',
              color: 'var(--warning, #eab308)'
            }}>
              <Clock size={32} />
            </div>

            <h3 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '12px', color: 'var(--text-primary)' }}>
              Are you still there?
            </h3>
            
            <p style={{ fontSize: '15px', color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: '24px' }}>
              We've noticed you've been away for a while. To protect your account, you will be automatically logged out in:
            </p>

            <div style={{
              fontSize: '48px',
              fontWeight: 800,
              fontFamily: 'var(--font-display)',
              color: 'var(--warning, #eab308)',
              marginBottom: '32px',
              textShadow: '0 0 20px rgba(234, 179, 8, 0.3)'
            }}>
              {countdown}s
            </div>

            <button 
              onClick={onConfirm}
              className="btn btn-primary"
              style={{ 
                width: '100%',
                padding: '14px',
                fontSize: '16px',
                fontWeight: 600,
                borderRadius: 'var(--radius-md)'
              }}
            >
              Yes, I'm here
            </button>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default IdleWarningModal;
